<template>
    <div class="checklist-template-wrapper">
        <div class="main-content">
            <div class="row">
                <div class="col-md-12">
                    <div class="card">
                        <div class="card-header">
                            <div class="card-title">
                                {{ isDuplicando ? "Duplicar" : checklist_template.checklist_template_id ? "Editar" : "Novo" }}
                                Checklist
                            </div>
                        </div>

                        <hr style="margin-top: -4px" />

                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-12">
                                    <div v-if="isDuplicando" class="alert alert-info mb-3">
                                        <i class="fas fa-copy mr-1"></i>
                                        Você está duplicando um checklist existente. Altere o que precisar e clique em <strong>Salvar</strong> para criar uma nova cópia.
                                    </div>
                                    <form @submit.prevent="save">
                                        <div class="form-row">
                                            <div class="form-group col-md-12">
                                                <label for="Name">
                                                    <span class="required">*</span> Nome do Template
                                                </label>
                                                <input
                                                    id="Name"
                                                    type="text"
                                                    class="form-control"
                                                    autocomplete="off"
                                                    v-model="checklist_template.nome"
                                                    placeholder="Digite o nome do template de checklist"
                                                />
                                            </div>
                                        </div>

                                        <div class="form-row">
                                            <div class="form-group col-md-12" v-if="isAdminLogged">
                                                <label for="inputCompany">
                                                    <span class="required">*</span> Empresa:
                                                </label>

                                                <select
                                                    id="inputCompany"
                                                    class="form-control"
                                                    v-model="checklist_template.company_id"
                                                    @change="onChangeCompany"
                                                >
                                                    <option :value="null">Selecione</option>
                                                    <option
                                                        v-for="company in companies"
                                                        :key="company.id"
                                                        :value="Number(company.id)"
                                                    >
                                                        {{ company.name }}
                                                    </option>
                                                </select>
                                            </div>
                                        </div>

                                        <div class="form-row">
                                            <div class="form-group col-md-10">
                                                <label for="unitSelect">
                                                    <span class="required">*</span> Unidades
                                                </label>

                                                <v-select
                                                    id="unitSelect"
                                                    v-model="checklist_template.units"
                                                    :options="filteredUnits"
                                                    :reduce="unit => unit.id"
                                                    label="name"
                                                    multiple
                                                >
                                                    <template #no-options>
                                                        Nenhuma unidade encontrada
                                                    </template>
                                                </v-select>
                                            </div>

                                            <div class="form-group col-md-2">
                                                <label>&nbsp;</label><br />
                                                <button
                                                    type="button"
                                                    class="btn btn-primary btn-block"
                                                    @click="selectAllUnits"
                                                    :disabled="allUnitsSelected"
                                                >
                                                    <i class="fas fa-check-double"></i> Todas
                                                </button>
                                            </div>
                                        </div>

                                        <div class="form-row">
                                            <div class="form-group col-md-12">
                                                <div class="custom-control custom-switch">
                                                    <input
                                                        type="checkbox"
                                                        class="custom-control-input"
                                                        id="exibirObservacao"
                                                        v-model="checklist_template.exibir_observacao"
                                                    />
                                                    <label class="custom-control-label" for="exibirObservacao">
                                                        Exibir observação no Histórico de Checklists
                                                    </label>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="form-row">
                                            <div class="form-group col-md-12">
                                                <label>Informações iniciais</label>
                                                <ckeditor
                                                    :editor="editor"
                                                    v-model="checklist_template.informacoes_iniciais"
                                                    :config="editorConfig"
                                                />
                                            </div>
                                        </div>

                                        <div class="row mt-4">
                                            <div class="col-md-12">
                                                <div class="grupos-management">
                                                    <div class="grupos-header">
                                                        <h5><i class="fas fa-layer-group"></i> Grupos da Checklist</h5>

                                                        <div>
                                                            <button
                                                                type="button"
                                                                class="btn btn-outline-success btn-sm mr-2"
                                                                @click="abrirImportModal"
                                                            >
                                                                <i class="fas fa-file-excel"></i> Importar Planilha
                                                            </button>

                                                            <button
                                                                type="button"
                                                                class="btn btn-primary btn-sm"
                                                                @click="adicionarNovoGrupo"
                                                            >
                                                                <i class="fas fa-plus"></i> Criar Novo Grupo
                                                            </button>
                                                        </div>
                                                    </div>

                                                    <div class="grupos-container">
                                                        <draggable
                                                            v-model="novos_grupos"
                                                            handle=".drag-handle"
                                                            ghost-class="dragging-ghost"
                                                            class="grupos-novos-section"
                                                        >
                                                        <div
                                                            v-for="(novoGrupo, index) in novos_grupos"
                                                            :key="'novo-' + index"
                                                            class="grupo-card grupo-novo"
                                                        >
                                                            <div class="grupo-header">
                                                                <div class="grupo-title">
                                                                    <span class="drag-handle mr-2" title="Arrastar para reordenar">
                                                                        <i class="fas fa-grip-vertical text-muted"></i>
                                                                    </span>
                                                                    <input
                                                                        type="text"
                                                                        class="form-control grupo-nome-input"
                                                                        v-model="novoGrupo.titulo"
                                                                        placeholder="Nome do grupo"
                                                                        @blur="validarNomeGrupo(novoGrupo, index)"
                                                                    />
                                                                </div>

                                                                <div class="grupo-actions">
                                                                    <button
                                                                        type="button"
                                                                        class="btn btn-sm btn-outline-info mr-1"
                                                                        @click="duplicarNovoGrupo(index)"
                                                                        title="Duplicar grupo com todos os itens"
                                                                    >
                                                                        <i class="fas fa-clone"></i>
                                                                    </button>

                                                                    <button
                                                                        type="button"
                                                                        class="btn btn-sm btn-outline-secondary mr-1"
                                                                        @click="toggleGrupoCollapse('novo', index)"
                                                                    >
                                                                        <i
                                                                            class="fas"
                                                                            :class="novoGrupo.collapsed ? 'fa-chevron-down' : 'fa-chevron-up'"
                                                                        ></i>
                                                                    </button>

                                                                    <button
                                                                        type="button"
                                                                        class="btn btn-sm btn-outline-danger"
                                                                        @click="confirmarRemoverNovoGrupo(index)"
                                                                    >
                                                                        <i class="fas fa-trash"></i>
                                                                    </button>
                                                                </div>
                                                            </div>

                                                            <div class="grupo-itens" v-show="!novoGrupo.collapsed">
                                                                <draggable
                                                                    v-model="novoGrupo.itens"
                                                                    handle=".drag-handle-item"
                                                                    ghost-class="dragging-ghost"
                                                                >
                                                                <div
                                                                    v-if="novoGrupo.itens && novoGrupo.itens.length > 0"
                                                                    v-for="(item, itemIndex) in novoGrupo.itens"
                                                                    :key="itemIndex"
                                                                    class="item-linha"
                                                                >
                                                                    <span class="drag-handle-item mr-1" title="Arrastar para reordenar">
                                                                        <i class="fas fa-grip-vertical text-muted"></i>
                                                                    </span>
                                                                    <div class="item-content">
                                                                        <input
                                                                            type="text"
                                                                            class="form-control item-nome"
                                                                            v-model="item.titulo"
                                                                            placeholder="Nome do item"
                                                                        />

                                                                        <select
                                                                            class="form-control item-tipo"
                                                                            v-model="item.tipo_pergunta"
                                                                        >
                                                                            <option
                                                                                v-for="tipo in tipos_resposta"
                                                                                :key="tipo.id"
                                                                                :value="tipo.id"
                                                                            >
                                                                                {{ tipo.titulo }}
                                                                            </option>
                                                                        </select>

                                                                        <div class="custom-control custom-switch item-obrigatorio-switch">
                                                                            <input
                                                                                type="checkbox"
                                                                                class="custom-control-input"
                                                                                :id="'obrig-novo-grupo-' + index + '-' + itemIndex"
                                                                                v-model="item.obrigatorio"
                                                                            />
                                                                            <label
                                                                                class="custom-control-label"
                                                                                :for="'obrig-novo-grupo-' + index + '-' + itemIndex"
                                                                            >
                                                                                {{ item.obrigatorio ? 'Obrig.' : 'Opcional' }}
                                                                            </label>
                                                                        </div>

                                                                        <b-form-datepicker
                                                                            v-if="Number(item.tipo_pergunta) === 5"
                                                                            v-model="item.data_esperada"
                                                                            class="item-quantidade-esperada item-data-esperada"
                                                                            locale="pt-BR"
                                                                            size="sm"
                                                                            placeholder="Data"
                                                                            title="Data esperada"
                                                                            :date-format-options="{ day: '2-digit', month: '2-digit', year: 'numeric' }"
                                                                            right
                                                                            today-button
                                                                            reset-button
                                                                            close-button
                                                                            label-today-button="Hoje"
                                                                            label-reset-button="Limpar"
                                                                            label-close-button="Fechar"
                                                                            label-no-date-selected="Nenhuma data selecionada"
                                                                            label-help="Use as setas do teclado para navegar"
                                                                            label-prev-month="Mês anterior"
                                                                            label-next-month="Próximo mês"
                                                                            label-current-month="Mês atual"
                                                                            label-prev-year="Ano anterior"
                                                                            label-next-year="Próximo ano"
                                                                        />
                                                                        <input
                                                                            v-else
                                                                            type="number"
                                                                            class="form-control item-quantidade-esperada"
                                                                            v-model.number="item.quantidade_esperada"
                                                                            placeholder="Qtd. esperada"
                                                                            title="Quantidade esperada"
                                                                            min="0"
                                                                        />

                                                                        <button
                                                                            type="button"
                                                                            class="btn btn-sm btn-outline-secondary"
                                                                            v-if="Number(item.tipo_pergunta) === 1"
                                                                            @click="gerenciarAlternativasNovoGrupo(index, itemIndex)"
                                                                        >
                                                                            <i class="fas fa-list"></i>
                                                                            {{ item.alternativas ? item.alternativas.length : 0 }}
                                                                        </button>
                                                                    </div>

                                                                    <button
                                                                        type="button"
                                                                        class="btn btn-sm btn-outline-danger"
                                                                        @click="removerItemDoNovoGrupo(index, itemIndex)"
                                                                    >
                                                                        <i class="fas fa-times"></i>
                                                                    </button>

                                                                    <div
                                                                        v-if="Number(item.tipo_pergunta) === 1 && item.mostrarAlternativas"
                                                                        class="alternativas-section"
                                                                    >
                                                                        <div class="alternativas-header">
                                                                            <span>Opções de resposta:</span>
                                                                            <div class="custom-control custom-switch ml-3">
                                                                                <input
                                                                                    type="checkbox"
                                                                                    class="custom-control-input"
                                                                                    :id="'mc-novo-grupo-' + index + '-' + itemIndex"
                                                                                    v-model="item.multipla_escolha"
                                                                                />
                                                                                <label class="custom-control-label" :for="'mc-novo-grupo-' + index + '-' + itemIndex">
                                                                                    Múltipla escolha
                                                                                </label>
                                                                            </div>
                                                                            <button
                                                                                type="button"
                                                                                class="btn btn-xs btn-success ml-auto"
                                                                                @click="adicionarAlternativaNovoGrupo(item)"
                                                                            >
                                                                                <i class="fas fa-plus"></i>
                                                                            </button>
                                                                        </div>

                                                                        <div
                                                                            v-if="item.alternativas"
                                                                            v-for="(alternativa, altIndex) in item.alternativas"
                                                                            :key="altIndex"
                                                                            class="alternativa-linha"
                                                                        >
                                                                            <input
                                                                                type="text"
                                                                                class="form-control"
                                                                                v-model="alternativa.titulo"
                                                                                placeholder="Digite a opção"
                                                                            />

                                                                            <button
                                                                                type="button"
                                                                                class="btn btn-xs btn-outline-danger"
                                                                                @click="removerAlternativaNovoGrupo(item, altIndex)"
                                                                            >
                                                                                <i class="fas fa-times"></i>
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                </draggable>

                                                                <div class="adicionar-item">
                                                                    <button
                                                                        type="button"
                                                                        class="btn btn-sm btn-outline-success"
                                                                        @click="adicionarItemAoNovoGrupo(index)"
                                                                    >
                                                                        <i class="fas fa-plus"></i> Adicionar item
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        </draggable>

                                                        <draggable
                                                            v-model="selectedGroupsDetails"
                                                            handle=".drag-handle"
                                                            ghost-class="dragging-ghost"
                                                            class="grupos-existentes-section"
                                                        >
                                                        <div
                                                            v-for="grupo in selectedGroupsDetails"
                                                            :key="grupo.grupo_checklist_id"
                                                            class="grupo-card grupo-existente"
                                                        >
                                                            <div class="grupo-header">
                                                                <div class="grupo-title">
                                                                    <span class="drag-handle mr-2" title="Arrastar para reordenar">
                                                                        <i class="fas fa-grip-vertical text-muted"></i>
                                                                    </span>
                                                                    <template v-if="!grupo.editandoNome">
                                                                        <h6>{{ grupo.titulo }}</h6>
                                                                        <span class="grupo-status">
                                                                            {{ grupo.itens_existentes.length }} itens existentes
                                                                        </span>
                                                                    </template>
                                                                    <template v-else>
                                                                        <input
                                                                            type="text"
                                                                            class="form-control grupo-nome-input"
                                                                            v-model="grupo.tituloEditando"
                                                                            placeholder="Nome do grupo"
                                                                            @keyup.enter="salvarNomeGrupo(grupo)"
                                                                            @keyup.esc="cancelarEdicaoNomeGrupo(grupo)"
                                                                        />
                                                                    </template>
                                                                </div>

                                                                <div class="grupo-actions">
                                                                    <template v-if="!grupo.editandoNome">
                                                                        <button
                                                                            type="button"
                                                                            class="btn btn-sm btn-outline-primary mr-1"
                                                                            @click="editarNomeGrupo(grupo)"
                                                                            title="Editar nome do grupo"
                                                                        >
                                                                            <i class="fas fa-edit"></i>
                                                                        </button>
                                                                    </template>
                                                                    <template v-else>
                                                                        <button
                                                                            type="button"
                                                                            class="btn btn-sm btn-success mr-1"
                                                                            @click="salvarNomeGrupo(grupo)"
                                                                            title="Salvar nome"
                                                                        >
                                                                            <i class="fas fa-check"></i>
                                                                        </button>
                                                                        <button
                                                                            type="button"
                                                                            class="btn btn-sm btn-secondary mr-1"
                                                                            @click="cancelarEdicaoNomeGrupo(grupo)"
                                                                            title="Cancelar"
                                                                        >
                                                                            <i class="fas fa-times"></i>
                                                                        </button>
                                                                    </template>

                                                                    <button
                                                                        type="button"
                                                                        class="btn btn-sm btn-outline-info mr-1"
                                                                        @click="duplicarGrupoExistente(grupo)"
                                                                        title="Duplicar grupo com todos os itens"
                                                                    >
                                                                        <i class="fas fa-clone"></i>
                                                                    </button>

                                                                    <button
                                                                        type="button"
                                                                        class="btn btn-sm btn-outline-secondary mr-1"
                                                                        @click="toggleGrupoCollapse('existente', grupo.grupo_checklist_id)"
                                                                    >
                                                                        <i
                                                                            class="fas"
                                                                            :class="grupo.collapsed ? 'fa-chevron-down' : 'fa-chevron-up'"
                                                                        ></i>
                                                                    </button>

                                                                    <button
                                                                        type="button"
                                                                        class="btn btn-sm btn-outline-danger"
                                                                        @click="confirmarDeleteGrupoExistente(grupo)"
                                                                        title="Deletar grupo e todos os seus itens"
                                                                    >
                                                                        <i class="fas fa-trash"></i>
                                                                    </button>
                                                                </div>
                                                            </div>

                                                            <div class="grupo-itens" v-show="!grupo.collapsed">
                                                                <div
                                                                    class="itens-existentes"
                                                                >
                                                                    <draggable
                                                                        :list="grupo.itens_existentes"
                                                                        handle=".drag-handle-item"
                                                                        ghost-class="dragging-ghost"
                                                                        :group="'perguntas-existentes'"
                                                                        class="itens-drop-zone"
                                                                        @end="onItensExistentesReorder()"
                                                                    >
                                                                    <div
                                                                        v-for="item in grupo.itens_existentes"
                                                                        :key="item.item_checklist_id"
                                                                        class="item-existente"
                                                                    >
                                                                        <div v-if="!item.editando" class="item-view-mode">
                                                                            <span class="drag-handle-item mr-2" title="Arrastar para reordenar">
                                                                                <i class="fas fa-grip-vertical text-muted"></i>
                                                                            </span>
                                                                            <div class="item-info">
                                                                                <span class="item-titulo">{{ item.titulo }}</span>
                                                                                <span
                                                                                    class="badge badge-tipo"
                                                                                    :class="getTipoBadgeClass(item.tipo_pergunta)"
                                                                                >
                                                                                    {{ getTipoLabel(item.tipo_pergunta) }}
                                                                                </span>
                                                                                <span class="badge badge-obrigatorio" :class="!!item.obrigatorio ? 'badge-obrig' : 'badge-opcional'">
                                                                                    {{ !!item.obrigatorio ? 'Obrigatório' : 'Opcional' }}
                                                                                </span>
                                                                                <span
                                                                                    v-if="Number(item.tipo_pergunta) !== 5 && item.quantidade_esperada !== null && item.quantidade_esperada !== undefined"
                                                                                    class="badge badge-secondary"
                                                                                    title="Quantidade esperada"
                                                                                >
                                                                                    Qtd: {{ item.quantidade_esperada }}
                                                                                </span>
                                                                                <span
                                                                                    v-if="Number(item.tipo_pergunta) === 5 && item.data_esperada"
                                                                                    class="badge badge-secondary"
                                                                                    title="Data esperada"
                                                                                >
                                                                                    Data: {{ formatarData(item.data_esperada) }}
                                                                                </span>
                                                                            </div>

                                                                            <div class="item-actions">
                                                                                <button
                                                                                    type="button"
                                                                                    class="btn btn-xs btn-primary mr-1"
                                                                                    @click="editarItemExistente(item)"
                                                                                    title="Editar item (nome e tipo de resposta)"
                                                                                >
                                                                                    <i class="fas fa-edit"></i> Editar
                                                                                </button>

                                                                                <button
                                                                                    type="button"
                                                                                    class="btn btn-xs btn-danger"
                                                                                    @click="confirmarDeleteItemExistente(grupo, item)"
                                                                                    title="Deletar item"
                                                                                >
                                                                                    <i class="fas fa-trash"></i>
                                                                                </button>
                                                                            </div>
                                                                        </div>

                                                                        <div v-else class="item-edit-mode">
                                                                            <div class="item-edit-header">
                                                                                <i class="fas fa-edit text-primary"></i>
                                                                                <span class="text-primary font-weight-bold">Editando item</span>
                                                                            </div>
                                                                            <div class="item-content">
                                                                                <input
                                                                                    type="text"
                                                                                    class="form-control item-nome"
                                                                                    v-model="item.titulo"
                                                                                    placeholder="Digite o nome do item"
                                                                                />

                                                                                <select
                                                                                    class="form-control item-tipo"
                                                                                    v-model="item.tipo_pergunta"
                                                                                >
                                                                                    <option
                                                                                        v-for="tipo in tipos_resposta"
                                                                                        :key="tipo.id"
                                                                                        :value="tipo.id"
                                                                                    >
                                                                                        {{ tipo.titulo }}
                                                                                    </option>
                                                                                </select>

                                                                                <div class="custom-control custom-switch item-obrigatorio-switch">
                                                                                    <input
                                                                                        type="checkbox"
                                                                                        class="custom-control-input"
                                                                                        :id="'obrig-existente-' + item.item_checklist_id"
                                                                                        v-model="item.obrigatorio"
                                                                                    />
                                                                                    <label
                                                                                        class="custom-control-label"
                                                                                        :for="'obrig-existente-' + item.item_checklist_id"
                                                                                    >
                                                                                        {{ !!item.obrigatorio ? 'Obrig.' : 'Opcional' }}
                                                                                    </label>
                                                                                </div>

                                                                                <b-form-datepicker
                                                                                    v-if="Number(item.tipo_pergunta) === 5"
                                                                                    v-model="item.data_esperada"
                                                                                    class="item-quantidade-esperada item-data-esperada"
                                                                                    locale="pt-BR"
                                                                                    size="sm"
                                                                                    placeholder="Data"
                                                                                    title="Data esperada"
                                                                                    :date-format-options="{ day: '2-digit', month: '2-digit', year: 'numeric' }"
                                                                                    right
                                                                                    today-button
                                                                                    reset-button
                                                                                    close-button
                                                                                    label-today-button="Hoje"
                                                                                    label-reset-button="Limpar"
                                                                                    label-close-button="Fechar"
                                                                                    label-no-date-selected="Nenhuma data selecionada"
                                                                                    label-help="Use as setas do teclado para navegar"
                                                                                    label-prev-month="Mês anterior"
                                                                                    label-next-month="Próximo mês"
                                                                                    label-current-month="Mês atual"
                                                                                    label-prev-year="Ano anterior"
                                                                                    label-next-year="Próximo ano"
                                                                                />
                                                                                <input
                                                                                    v-else
                                                                                    type="number"
                                                                                    class="form-control item-quantidade-esperada"
                                                                                    v-model.number="item.quantidade_esperada"
                                                                                    placeholder="Qtd. esperada"
                                                                                    title="Quantidade esperada"
                                                                                    min="0"
                                                                                />

                                                                                <button
                                                                                    type="button"
                                                                                    class="btn btn-sm btn-outline-secondary"
                                                                                    v-if="Number(item.tipo_pergunta) === 1"
                                                                                    @click="gerenciarAlternativasItemExistente(item)"
                                                                                    title="Gerenciar opções de resposta"
                                                                                >
                                                                                    <i class="fas fa-list"></i>
                                                                                    {{ item.itens ? item.itens.length : 0 }} opções
                                                                                </button>
                                                                            </div>

                                                                            <div class="item-actions">
                                                                                <button
                                                                                    type="button"
                                                                                    class="btn btn-sm btn-success mr-1"
                                                                                    @click="salvarEdicaoItemExistente(item)"
                                                                                    title="Salvar alterações"
                                                                                >
                                                                                    <i class="fas fa-check"></i> Salvar
                                                                                </button>

                                                                                <button
                                                                                    type="button"
                                                                                    class="btn btn-sm btn-secondary"
                                                                                    @click="cancelarEdicaoItemExistente(item)"
                                                                                    title="Cancelar edição"
                                                                                >
                                                                                    <i class="fas fa-times"></i> Cancelar
                                                                                </button>
                                                                            </div>

                                                                            <div
                                                                                v-if="Number(item.tipo_pergunta) === 1 && item.mostrarAlternativas"
                                                                                class="alternativas-section"
                                                                            >
                                                                                <div class="alternativas-header">
                                                                                    <span>Opções de resposta:</span>
                                                                                    <div class="custom-control custom-switch ml-3">
                                                                                        <input
                                                                                            type="checkbox"
                                                                                            class="custom-control-input"
                                                                                            :id="'mc-existente-' + item.item_checklist_id"
                                                                                            v-model="item.multipla_escolha"
                                                                                        />
                                                                                        <label class="custom-control-label" :for="'mc-existente-' + item.item_checklist_id">
                                                                                            Múltipla escolha
                                                                                        </label>
                                                                                    </div>
                                                                                    <button
                                                                                        type="button"
                                                                                        class="btn btn-xs btn-success ml-auto"
                                                                                        @click="adicionarAlternativaItemExistente(item)"
                                                                                    >
                                                                                        <i class="fas fa-plus"></i>
                                                                                    </button>
                                                                                </div>

                                                                                <div
                                                                                    v-if="item.itens"
                                                                                    v-for="(alternativa, altIndex) in item.itens"
                                                                                    :key="altIndex"
                                                                                >
                                                                                    <div class="alternativa-linha">
                                                                                        <input
                                                                                            type="text"
                                                                                            class="form-control"
                                                                                            v-model="alternativa.titulo"
                                                                                            placeholder="Digite a opção"
                                                                                        />

                                                                                        <button
                                                                                            type="button"
                                                                                            class="btn btn-xs"
                                                                                            :class="alternativa.item_vinculado_id ? 'btn-warning' : 'btn-outline-secondary'"
                                                                                            @click="$set(alternativa, '_mostrarVinculo', !alternativa._mostrarVinculo)"
                                                                                            :title="alternativa.item_vinculado_id ? 'Pergunta vinculada: ' + getNomeItemVinculado(grupo, alternativa.item_vinculado_id) : 'Vincular a uma pergunta condicional'"
                                                                                        >
                                                                                            <i class="fas fa-link"></i>
                                                                                            <span class="ml-1" v-if="alternativa.item_vinculado_id">Vinculado</span>
                                                                                            <span class="ml-1" v-else>Vincular</span>
                                                                                        </button>

                                                                                        <button
                                                                                            type="button"
                                                                                            class="btn btn-xs btn-outline-danger"
                                                                                            @click="removerAlternativaItemExistente(item, altIndex)"
                                                                                        >
                                                                                            <i class="fas fa-times"></i>
                                                                                        </button>
                                                                                    </div>

                                                                                    <!-- Painel de vínculo expandido -->
                                                                                    <div v-if="alternativa._mostrarVinculo" class="vinculo-panel">
                                                                                        <div class="vinculo-panel-header">
                                                                                            <i class="fas fa-project-diagram text-warning mr-2"></i>
                                                                                            <strong>Pergunta condicional para "{{ alternativa.titulo || 'esta opção' }}"</strong>
                                                                                            <small class="text-muted ml-2">— Aparece quando o usuário selecionar esta resposta</small>
                                                                                        </div>
                                                                                        <div class="d-flex align-items-center gap-2 mt-2">
                                                                                            <select
                                                                                                class="form-control"
                                                                                                v-model="alternativa.item_vinculado_id"
                                                                                            >
                                                                                                <option :value="null">— Nenhuma (sem vínculo) —</option>
                                                                                                <option
                                                                                                    v-for="outroItem in grupo.itens_existentes.filter(i => i.item_checklist_id !== item.item_checklist_id)"
                                                                                                    :key="outroItem.item_checklist_id"
                                                                                                    :value="outroItem.item_checklist_id"
                                                                                                >
                                                                                                    {{ outroItem.titulo }}
                                                                                                </option>
                                                                                            </select>
                                                                                            <button
                                                                                                v-if="alternativa.item_vinculado_id"
                                                                                                type="button"
                                                                                                class="btn btn-xs btn-outline-danger"
                                                                                                @click="$set(alternativa, 'item_vinculado_id', null)"
                                                                                                title="Remover vínculo"
                                                                                            >
                                                                                                <i class="fas fa-unlink"></i> Remover
                                                                                            </button>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    </draggable>
                                                                </div>

                                                                <draggable
                                                                    v-model="grupo.novos_itens"
                                                                    handle=".drag-handle-item"
                                                                    ghost-class="dragging-ghost"
                                                                >
                                                                <div
                                                                    v-if="grupo.novos_itens && grupo.novos_itens.length > 0"
                                                                    v-for="(novoItem, index) in grupo.novos_itens"
                                                                    :key="index"
                                                                    class="item-linha"
                                                                >
                                                                    <span class="drag-handle-item mr-1" title="Arrastar para reordenar">
                                                                        <i class="fas fa-grip-vertical text-muted"></i>
                                                                    </span>
                                                                    <div class="item-content">
                                                                        <input
                                                                            type="text"
                                                                            class="form-control item-nome"
                                                                            v-model="novoItem.titulo"
                                                                            placeholder="Nome do item"
                                                                        />

                                                                        <select
                                                                            class="form-control item-tipo"
                                                                            v-model="novoItem.tipo_pergunta"
                                                                        >
                                                                            <option
                                                                                v-for="tipo in tipos_resposta"
                                                                                :key="tipo.id"
                                                                                :value="tipo.id"
                                                                            >
                                                                                {{ tipo.titulo }}
                                                                            </option>
                                                                        </select>

                                                                        <div class="custom-control custom-switch item-obrigatorio-switch">
                                                                            <input
                                                                                type="checkbox"
                                                                                class="custom-control-input"
                                                                                :id="'obrig-novo-item-' + grupo.grupo_checklist_id + '-' + index"
                                                                                v-model="novoItem.obrigatorio"
                                                                            />
                                                                            <label
                                                                                class="custom-control-label"
                                                                                :for="'obrig-novo-item-' + grupo.grupo_checklist_id + '-' + index"
                                                                            >
                                                                                {{ novoItem.obrigatorio ? 'Obrig.' : 'Opcional' }}
                                                                            </label>
                                                                        </div>

                                                                        <b-form-datepicker
                                                                            v-if="Number(novoItem.tipo_pergunta) === 5"
                                                                            v-model="novoItem.data_esperada"
                                                                            class="item-quantidade-esperada item-data-esperada"
                                                                            locale="pt-BR"
                                                                            size="sm"
                                                                            placeholder="Data"
                                                                            title="Data esperada"
                                                                            :date-format-options="{ day: '2-digit', month: '2-digit', year: 'numeric' }"
                                                                            right
                                                                            today-button
                                                                            reset-button
                                                                            close-button
                                                                            label-today-button="Hoje"
                                                                            label-reset-button="Limpar"
                                                                            label-close-button="Fechar"
                                                                            label-no-date-selected="Nenhuma data selecionada"
                                                                            label-help="Use as setas do teclado para navegar"
                                                                            label-prev-month="Mês anterior"
                                                                            label-next-month="Próximo mês"
                                                                            label-current-month="Mês atual"
                                                                            label-prev-year="Ano anterior"
                                                                            label-next-year="Próximo ano"
                                                                        />
                                                                        <input
                                                                            v-else
                                                                            type="number"
                                                                            class="form-control item-quantidade-esperada"
                                                                            v-model.number="novoItem.quantidade_esperada"
                                                                            placeholder="Qtd. esperada"
                                                                            title="Quantidade esperada"
                                                                            min="0"
                                                                        />

                                                                        <button
                                                                            type="button"
                                                                            class="btn btn-sm btn-outline-secondary"
                                                                            v-if="Number(novoItem.tipo_pergunta) === 1"
                                                                            @click="gerenciarAlternativas(grupo, index)"
                                                                        >
                                                                            <i class="fas fa-list"></i>
                                                                            {{ novoItem.itens ? novoItem.itens.length : 0 }}
                                                                        </button>
                                                                    </div>

                                                                    <button
                                                                        type="button"
                                                                        class="btn btn-sm btn-outline-danger"
                                                                        @click="removerNovoItem(grupo, index)"
                                                                    >
                                                                        <i class="fas fa-times"></i>
                                                                    </button>

                                                                    <div
                                                                        v-if="Number(novoItem.tipo_pergunta) === 1 && novoItem.mostrarAlternativas"
                                                                        class="alternativas-section"
                                                                    >
                                                                        <div class="alternativas-header">
                                                                            <span>Opções de resposta:</span>
                                                                            <div class="custom-control custom-switch ml-3">
                                                                                <input
                                                                                    type="checkbox"
                                                                                    class="custom-control-input"
                                                                                    :id="'mc-novoitem-' + grupo.grupo_checklist_id + '-' + index"
                                                                                    v-model="novoItem.multipla_escolha"
                                                                                />
                                                                                <label class="custom-control-label" :for="'mc-novoitem-' + grupo.grupo_checklist_id + '-' + index">
                                                                                    Múltipla escolha
                                                                                </label>
                                                                            </div>
                                                                            <button
                                                                                type="button"
                                                                                class="btn btn-xs btn-success ml-auto"
                                                                                @click="adicionarAlternativa(novoItem)"
                                                                            >
                                                                                <i class="fas fa-plus"></i>
                                                                            </button>
                                                                        </div>

                                                                        <div
                                                                            v-if="novoItem.itens"
                                                                            v-for="(alternativa, altIndex) in novoItem.itens"
                                                                            :key="altIndex"
                                                                            class="alternativa-linha"
                                                                        >
                                                                            <input
                                                                                type="text"
                                                                                class="form-control"
                                                                                v-model="alternativa.titulo"
                                                                                placeholder="Digite a opção"
                                                                            />

                                                                            <button
                                                                                type="button"
                                                                                class="btn btn-xs btn-outline-danger"
                                                                                @click="removerAlternativa(novoItem, altIndex)"
                                                                            >
                                                                                <i class="fas fa-times"></i>
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                </draggable>

                                                                <div class="adicionar-item">
                                                                    <button
                                                                        type="button"
                                                                        class="btn btn-sm btn-outline-success"
                                                                        @click="adicionarNovoItem(grupo)"
                                                                    >
                                                                        <i class="fas fa-plus"></i> Adicionar item
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        </draggable>

                                                        <div
                                                            v-if="novos_grupos.length === 0 && selectedGroupsDetails.length === 0"
                                                            class="sem-grupos"
                                                        >
                                                            <i class="fas fa-info-circle"></i>
                                                            <p>Crie um novo grupo</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <span class="required_fields">
                                            <span class="required">*</span>
                                            <strong>Campos obrigatórios</strong>
                                        </span>

                                        <div class="block text-right">
                                            <router-link to="/checklisttemplates" class="btn btn-back mr-1">
                                                <i class="fa fa-arrow-left"></i> Voltar
                                            </router-link>

                                            <button
                                                type="submit"
                                                class="btn btn-add"
                                                :disabled="saving"
                                            >
                                                Salvar
                                                <i class="fa fa-save"></i>
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="showDeleteNovoGrupoModal" class="modal-overlay-custom" @click.self="cancelarDeleteNovoGrupo">
            <div class="modal-dialog-custom">
                <div class="modal-content-custom">
                    <div class="modal-body">
                        <h4 class="bold">Tem certeza que deseja remover esse grupo?</h4>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="cancelarDeleteNovoGrupo">
                            Não
                        </button>
                        <button type="button" class="btn btn-warning" @click="removerNovoGrupo">
                            Sim
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="showDeleteModal" class="modal-overlay-custom" @click.self="cancelarDeleteGrupo">
            <div class="modal-dialog-custom">
                <div class="modal-content-custom">
                    <div class="modal-body">
                        <div v-if="grupoParaDeletar" class="text-center">
                            <h4 class="mb-3 bold">Tem certeza que deseja deletar o grupo:</h4>
                            <div class="alert alert-warning">
                                <strong>"{{ grupoParaDeletar.titulo }}"</strong>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="cancelarDeleteGrupo">
                            Cancelar
                        </button>
                        <button type="button" class="btn btn-danger" @click="deletarGrupoExistente">
                            Confirmar
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="showImportModal" class="modal-overlay-custom" @click.self="fecharImportModal">
            <div class="modal-dialog-custom" style="max-width: 650px">
                <div class="modal-content-custom">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            <i class="fas fa-file-excel"></i> Importar Grupos e Itens via Planilha
                        </h5>
                    </div>
                    <div class="modal-body">
                        <div class="alert alert-info">
                            Baixe o modelo abaixo, preencha uma linha para cada item
                            (colunas <strong>Grupo</strong>, <strong>Nome do Item</strong>,
                            <strong>Tipo de Resposta</strong> - Texto, Alternativa, Número,
                            Imagem ou Data, <strong>Obrigatório</strong> - Sim/Não,
                            <strong>Múltipla Escolha</strong> - Sim/Não,
                            <strong>Opções Disponíveis</strong> - separadas por
                            <strong>;</strong>, só quando Tipo de Resposta for Alternativa, e
                            <strong>Quantidade Esperada</strong> - obrigatório, só número, e
                            <strong>Data Esperada</strong> - dd/mm/aaaa, obrigatório só quando
                            Tipo de Resposta for Data, que dispensa a quantidade) e
                            depois suba o arquivo aqui.
                        </div>

                        <button
                            type="button"
                            class="btn btn-outline-primary btn-sm mb-3"
                            @click="baixarModeloImportacao"
                            :disabled="baixandoModelo"
                        >
                            <span v-if="baixandoModelo"><i class="fas fa-spinner fa-spin"></i> Gerando...</span>
                            <span v-else><i class="fas fa-download"></i> Baixar modelo da planilha</span>
                        </button>

                        <div class="form-group">
                            <label>
                                <span class="required">*</span> Planilha (.xlsx, .xls, .csv):
                            </label>
                            <input
                                ref="fileImportRef"
                                type="file"
                                class="form-control-file"
                                accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                            />
                        </div>

                        <div v-if="importErrors.length" class="mt-2">
                            <p class="mb-1">
                                <strong>Linhas com problema ({{ importErrors.length }}):</strong>
                            </p>
                            <div class="table-responsive" style="max-height: 220px; overflow-y: auto">
                                <table class="table table-sm table-bordered mb-0">
                                    <thead class="thead-light">
                                        <tr>
                                            <th style="width: 70px">Linha</th>
                                            <th style="width: 130px">Campo</th>
                                            <th>Motivo</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(err, i) in importErrors" :key="i" class="table-warning">
                                            <td class="text-center">{{ err.linha }}</td>
                                            <td><code>{{ err.campo }}</code></td>
                                            <td>{{ err.mensagem }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="fecharImportModal">
                            Cancelar
                        </button>
                        <button type="button" class="btn btn-add" @click="importarPlanilha" :disabled="importing">
                            <span v-if="importing"><i class="fas fa-spinner fa-spin"></i> Importando...</span>
                            <span v-else><i class="fas fa-upload"></i> Importar</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="showDeleteItemModal" class="modal-overlay-custom" @click.self="cancelarDeleteItem">
            <div class="modal-dialog-custom">
                <div class="modal-content-custom">
                    <div class="modal-header bg-warning text-dark">
                        <h5 class="modal-title">
                            <i class="fas fa-exclamation-triangle"></i>
                            Confirmar Exclusão do Item
                        </h5>
                    </div>
                    <div class="modal-body">
                        <div v-if="itemParaDeletar" class="text-center">
                            <h6 class="mb-3">Tem certeza que deseja deletar o item:</h6>
                            <div class="alert alert-info">
                                <strong>"{{ itemParaDeletar.item.titulo }}"</strong>
                            </div>
                            <p class="text-muted">Esta ação não pode ser desfeita.</p>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="cancelarDeleteItem">
                            Cancelar
                        </button>
                        <button type="button" class="btn btn-warning" @click="deletarItemExistente">
                            Sim, Deletar Item
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import vSelect from "vue-select";
import draggable from "vuedraggable";
import { BFormDatepicker } from "bootstrap-vue";
import CKEditor from "@ckeditor/ckeditor5-vue2";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import "@ckeditor/ckeditor5-build-classic/build/translations/pt-br";

// Plugin do CKEditor que envia as imagens coladas/selecionadas para a API.
// Precisa ser uma função comum: o CKEditor instancia os plugins com `new`,
// e métodos do Vue (sintaxe abreviada) não podem ser usados como construtor.
function criarUploadAdapterPlugin(apiBase) {
    return function UploadAdapterPlugin(editor) {
        editor.plugins.get("FileRepository").createUploadAdapter = loader => {
            const source = axios.CancelToken.source();

            return {
                upload: () => loader.file.then(file => {
                    const formData = new FormData();
                    formData.append("upload", file);

                    return axios
                        .post(apiBase + "checklisttemplates/upload-image", formData, {
                            cancelToken: source.token,
                            onUploadProgress: e => {
                                loader.uploadTotal = e.total;
                                loader.uploaded = e.loaded;
                            },
                        })
                        .then(response => ({
                            default: apiBase.replace("/api/v1/", "/") + "storage/" + response.data.path,
                        }))
                        .catch(error => {
                            const data = error.response?.data;
                            const message = data?.errors?.upload?.[0] || data?.message || "Erro ao enviar a imagem";
                            return Promise.reject(message);
                        });
                }),
                abort: () => source.cancel(),
            };
        };
    };
}

export default {
    components: {
        BaseCrud,
        vSelect,
        draggable,
        BFormDatepicker,
        ckeditor: CKEditor.component,
    },

    data() {
        return {
            saving: false,
            editor: ClassicEditor,
            editorConfig: {
                language: "pt-br",
                placeholder: "Digite as informações iniciais do checklist",
                extraPlugins: [criarUploadAdapterPlugin(this.$store.state.api)],
                toolbar: [
                    "heading", "|",
                    "bold", "italic", "link", "bulletedList", "numberedList", "|",
                    "uploadImage", "blockQuote", "insertTable", "|",
                    "undo", "redo",
                ],
                image: {
                    toolbar: [
                        "imageStyle:inline", "imageStyle:block", "imageStyle:side", "|",
                        "toggleImageCaption", "imageTextAlternative",
                    ],
                },
            },
            checklist_template: this.getEmptyChecklistTemplate(),
            companies: [],
            units: [],
            group_checklists: [],
            selectedGroupsDetails: [],
            novos_grupos: [],
            tipos_resposta: [
                { id: 1, titulo: "Alternativa" },
                { id: 2, titulo: "Texto" },
                { id: 3, titulo: "Número" },
                { id: 4, titulo: "Imagem" },
                { id: 5, titulo: "Data" },
            ],
            showDeleteModal: false,
            grupoParaDeletar: null,
            showDeleteItemModal: false,
            itemParaDeletar: null,
            showDeleteNovoGrupoModal: false,
            novoGrupoParaDeletar: null,
            editandoItem: false,
            isDuplicando: false,
            showImportModal: false,
            importing: false,
            importErrors: [],
            baixandoModelo: false,
        };
    },

    computed: {
        loggedUser() {
            return this.$store.state.auth?.user || this.$store.state.user || null;
        },

        isAdminLogged() {
            return Number(this.loggedUser?.perfil_id) === 1;
        },

        isGestorLogged() {
            return Number(this.loggedUser?.perfil_id) === 6;
        },

        isGestorOperacionalLogged() {
            return Number(this.loggedUser?.perfil_id) === 7;
        },

        isGestorComEmpresa() {
            return this.isGestorLogged || this.isGestorOperacionalLogged;
        },

        loggedCompanyId() {
            return this.loggedUser?.company_id ? Number(this.loggedUser.company_id) : null;
        },

        filteredUnits() {
            if (this.isGestorComEmpresa) {
                return Array.isArray(this.units) ? this.units : [];
            }

            if (!this.checklist_template.company_id) {
                return [];
            }

            return this.units.filter(
                unit => Number(unit.company_id) === Number(this.checklist_template.company_id)
            );
        },

        allUnitsSelected() {
            if (!this.filteredUnits.length) {
                return true;
            }
            return (
                Array.isArray(this.checklist_template.units) &&
                this.checklist_template.units.length === this.filteredUnits.length
            );
        },
    },

    watch: {
        "$route.params.id"(newId, oldId) {
            if (newId && newId !== oldId) {
                this.bootstrap();
                return;
            }

            if (!newId) {
                this.resetForm();
            }
        },

        "checklist_template.grupos_checklist": {
            handler() {
                this.carregarDetalhesGruposSelecionados();
            },
            deep: true,
        },
    },

    async mounted() {
        await this.bootstrap();
    },

    methods: {
        getEmptyChecklistTemplate() {
            return {
                checklist_template_id: null,
                nome: "",
                company_id: null,
                units: [],
                grupos_checklist: [],
                exibir_observacao: true,
                informacoes_iniciais: "",
            };
        },

        resetForm() {
            this.checklist_template = this.getEmptyChecklistTemplate();
            this.selectedGroupsDetails = [];
            this.novos_grupos = [];
            this.editandoItem = false;
            this.isDuplicando = false;
            this.applyLoggedCompanyToChecklist();
        },

        async bootstrap() {
            this.resetForm();

            await Promise.all([
                this.getCompanies(),
                this.getUnits(),
                this.getGrupoChecklist(),
            ]);

            this.applyLoggedCompanyToChecklist();

            const id = this.$route.params.id;

            if (id) {
                if (this.$route.name === 'DuplicateChecklistTemplate') {
                    this.isDuplicando = true;
                    await this.carregarParaDuplicar(id);
                } else {
                    await this.getChecklistTemplate(id);
                }
            }
        },

        async carregarParaDuplicar(id) {
            try {
                const api = this.$store.state.api + "checklisttemplates/" + id + "?with[]=grupos_checklist&with[]=units";
                const response = await axios.get(api);
                const data = response.data.data;

                this.checklist_template = {
                    checklist_template_id: null,
                    nome: data.nome || "",
                    company_id: data.company_id ? Number(data.company_id) : null,
                    units: Array.isArray(data.units) ? data.units.map(u => Number(u.id)) : [],
                    grupos_checklist: [],
                    exibir_observacao: data.exibir_observacao !== undefined ? !!data.exibir_observacao : true,
                    informacoes_iniciais: data.informacoes_iniciais || "",
                };

                if (this.isGestorComEmpresa) {
                    this.applyLoggedCompanyToChecklist();
                }

                const grupos = Array.isArray(data.grupos_checklist) ? data.grupos_checklist : [];

                for (const grupo of grupos) {
                    const itensResp = await axios.get(
                        this.$store.state.api + "itemchecklists?grupo_checklist_id=" + grupo.grupo_checklist_id + "&paginated=false"
                    );
                    const itens = itensResp.data.data || [];

                    const novosItens = [];

                    itens.sort((a, b) => {
                        if (a.ordem !== null && a.ordem !== undefined && b.ordem !== null && b.ordem !== undefined) {
                            return a.ordem - b.ordem;
                        }
                        if (a.ordem !== null && a.ordem !== undefined) return -1;
                        if (b.ordem !== null && b.ordem !== undefined) return 1;
                        return (a.titulo || "").localeCompare(b.titulo || "", "pt-BR", { sensitivity: "base" });
                    });

                    for (const item of itens) {
                        const novoItem = {
                            titulo: item.titulo,
                            tipo_pergunta: item.tipo_pergunta,
                            multipla_escolha: !!item.multipla_escolha,
                            alternativas: [],
                            mostrarAlternativas: false,
                        };

                        if (Number(item.tipo_pergunta) === 1) {
                            const altResp = await axios.get(
                                this.$store.state.api + "respostachecklists?item_checklist_id=" + item.item_checklist_id + "&paginated=false"
                            );
                            novoItem.alternativas = (altResp.data.data || []).map(a => ({ titulo: a.titulo }));
                        }

                        novosItens.push(novoItem);
                    }

                    this.novos_grupos.push({
                        titulo: grupo.titulo,
                        itens: novosItens,
                        collapsed: true,
                    });
                }
            } catch (error) {
                this.$message(null, error.response?.data || error, "error");
            }
        },

        async getCompanies() {
            try {
                const api = this.$store.state.api + "companies?paginated=false&status=1";
                const response = await axios.get(api);
                this.companies = response.data.data || [];
                this.applyLoggedCompanyToChecklist();
            } catch (error) {
                this.$message(null, error.response?.data || error, "error");
            }
        },

        async getUnits() {
            try {
                const api = this.$store.state.api + "units?paginated=false&status=1";
                const response = await axios.get(api);
                this.units = response.data.data || [];
            } catch (error) {
                this.$message(null, error.response?.data || error, "error");
            }
        },

        async getGrupoChecklist() {
            try {
                const api = this.$store.state.api + "groupchecklists?paginated=false";
                const response = await axios.get(api);
                this.group_checklists = response.data.data || [];
            } catch (error) {
                this.$message(null, error.response?.data || error, "error");
            }
        },

        async getChecklistTemplate(id) {
            try {
                const api = this.$store.state.api + "checklisttemplates/" + id + "?with[]=grupos_checklist&with[]=units";
                const response = await axios.get(api);
                const data = response.data.data;

                this.checklist_template = {
                    checklist_template_id: data.checklist_template_id,
                    nome: data.nome || "",
                    company_id: data.company_id ? Number(data.company_id) : null,
                    units: Array.isArray(data.units) ? data.units.map(unit => Number(unit.id)) : [],
                    grupos_checklist: Array.isArray(data.grupos_checklist)
                        ? data.grupos_checklist.map(grupo => Number(grupo.grupo_checklist_id))
                        : [],
                    exibir_observacao: data.exibir_observacao !== undefined ? !!data.exibir_observacao : true,
                    informacoes_iniciais: data.informacoes_iniciais || "",
                };

                if (this.isGestorComEmpresa) {
                    this.applyLoggedCompanyToChecklist();
                }
            } catch (error) {
                this.$message(null, error.response?.data || error, "error");
            }
        },

        onItensExistentesReorder() {
            // Apenas atualiza o estado LOCAL (grupo/ordem) enquanto o usuário
            // arrasta. NADA é persistido aqui — a gravação acontece só ao
            // clicar em "Salvar" (ver save()). Assim é possível mover livremente,
            // inclusive desfazer, e um refresh sem salvar volta ao estado original.
            this.selectedGroupsDetails.forEach(grupo => {
                (grupo.itens_existentes || []).forEach((item, index) => {
                    item.grupo_checklist_id = grupo.grupo_checklist_id;
                    item.ordem = index;
                });
            });
        },

        applyLoggedCompanyToChecklist() {
            if (!this.isGestorComEmpresa || !this.loggedCompanyId) {
                return;
            }

            this.checklist_template.company_id = this.loggedCompanyId;
        },

        onChangeCompany() {
            this.checklist_template.units = [];
        },

        selectAllUnits() {
            this.checklist_template.units = this.filteredUnits.map(u => u.id);
        },

        validarCamposObrigatorios() {
            if (!this.checklist_template.nome || !this.checklist_template.nome.trim()) {
                return {
                    valid: false,
                    message: "Preencha o Nome do Template.",
                };
            }

            if (!this.checklist_template.company_id && this.AdminLogged) {
                return {
                    valid: false,
                    message: "Selecione uma empresa.",
                };
            }

            if (!Array.isArray(this.checklist_template.units) || this.checklist_template.units.length === 0) {
                return {
                    valid: false,
                    message: "Você precisa selecionar ao menos uma unidade.",
                };
            }

            const totalGruposExistentes = Array.isArray(this.checklist_template.grupos_checklist)
                ? this.checklist_template.grupos_checklist.length
                : 0;

            const totalGruposNovos = Array.isArray(this.novos_grupos)
                ? this.novos_grupos.filter(grupo => grupo.titulo && grupo.titulo.trim()).length
                : 0;

            if (totalGruposExistentes === 0 && totalGruposNovos === 0) {
                return {
                    valid: false,
                    message: "Você precisa ter ao menos um grupo no checklist.",
                };
            }

            for (const grupo of this.novos_grupos) {
                if (!grupo.titulo || !grupo.titulo.trim()) {
                    return {
                        valid: false,
                        message: "Todos os grupos novos precisam ter nome.",
                    };
                }

                if (!Array.isArray(grupo.itens) || grupo.itens.length === 0) {
                    return {
                        valid: false,
                        message: `O grupo "${grupo.titulo || "sem nome"}" precisa ter ao menos um item.`,
                    };
                }

                for (const item of grupo.itens) {
                    if (!item.titulo || !item.titulo.trim()) {
                        return {
                            valid: false,
                            message: "Todos os itens precisam ter título.",
                        };
                    }

                    if (!item.tipo_pergunta) {
                        return {
                            valid: false,
                            message: "Todos os itens precisam ter tipo de resposta.",
                        };
                    }

                    if (Number(item.tipo_pergunta) === 1) {
                        if (!Array.isArray(item.alternativas) || item.alternativas.length === 0) {
                            return {
                                valid: false,
                                message: `O item "${item.titulo}" precisa ter ao menos uma alternativa.`,
                            };
                        }

                        const alternativaVazia = item.alternativas.some(
                            alternativa => !alternativa.titulo || !alternativa.titulo.trim()
                        );

                        if (alternativaVazia) {
                            return {
                                valid: false,
                                message: `Todas as alternativas do item "${item.titulo}" precisam ser preenchidas.`,
                            };
                        }
                    }
                }
            }

            // Validar grupos existentes - garantir que não fiquem sem itens
            for (const grupo of this.selectedGroupsDetails) {
                const itensExistentes = grupo.itens_existentes || [];
                const novosItens = grupo.novos_itens || [];
                const totalItens = itensExistentes.length + novosItens.length;

                if (totalItens === 0) {
                    return {
                        valid: false,
                        message: `O grupo "${grupo.titulo}" não pode ficar sem itens. Adicione pelo menos um item ou remova o grupo.`,
                    };
                }

                // Validar novos itens do grupo existente
                for (const item of novosItens) {
                    if (!item.titulo || !item.titulo.trim()) {
                        return {
                            valid: false,
                            message: "Todos os itens precisam ter título.",
                        };
                    }

                    if (!item.tipo_pergunta) {
                        return {
                            valid: false,
                            message: "Todos os itens precisam ter tipo de resposta.",
                        };
                    }

                    if (Number(item.tipo_pergunta) === 1) {
                        if (!Array.isArray(item.itens) || item.itens.length === 0) {
                            return {
                                valid: false,
                                message: `O item "${item.titulo}" precisa ter ao menos uma alternativa.`,
                            };
                        }

                        const alternativaVazia = item.itens.some(
                            alternativa => !alternativa.titulo || !alternativa.titulo.trim()
                        );

                        if (alternativaVazia) {
                            return {
                                valid: false,
                                message: `Todas as alternativas do item "${item.titulo}" precisam ser preenchidas.`,
                            };
                        }
                    }
                }
            }

            return { valid: true };
        },

        async save() {
            if (this.saving) {
                return;
            }

            const validationResult = this.validarCamposObrigatorios();

            if (!validationResult.valid) {
                this.$message("Erro de Validação", validationResult.message, "error");
                return;
            }

            this.saving = true;

            try {
                this.applyLoggedCompanyToChecklist();

                let gruposIds = [];

                if (this.checklist_template.checklist_template_id) {
                    // MODO EDIÇÃO
                    // 1. Manter IDs dos grupos existentes
                    gruposIds = this.selectedGroupsDetails.map(grupo => 
                        Number(grupo.grupo_checklist_id)
                    );

                    // 2. Criar novos itens em grupos existentes
                    const novosItensGruposExistentes = this.coletarNovosItens();
                    if (novosItensGruposExistentes && novosItensGruposExistentes.length > 0) {
                        for (const item of novosItensGruposExistentes) {
                            const itemResponse = await axios.post(
                                this.$store.state.api + "itemchecklists",
                                {
                                    grupo_checklist_id: item.grupo_checklist_id,
                                    titulo: item.titulo,
                                    tipo_pergunta: item.tipo_pergunta,
                                    obrigatorio: !!item.obrigatorio,
                                    quantidade_esperada: item.quantidade_esperada ?? null,
                                    data_esperada: item.data_esperada ?? null,
                                    multipla_escolha: !!item.multipla_escolha,
                                    ordem: item.ordem !== undefined ? item.ordem : null,
                                }
                            );

                            const itemId = itemResponse.data?.data?.item_checklist_id || 
                                         itemResponse.data?.item_checklist_id;

                            // Se for múltipla escolha (tipo 1), criar alternativas
                            if (Number(item.tipo_pergunta) === 1 && item.itens && item.itens.length > 0) {
                                for (const alternativa of item.itens) {
                                    await axios.post(
                                        this.$store.state.api + "respostachecklists",
                                        {
                                            item_checklist_id: itemId,
                                            titulo: alternativa.titulo,
                                        }
                                    );
                                }
                            }
                        }
                    }

                    // 3. Se houver novos grupos completos, criar eles
                    if (this.novos_grupos && this.novos_grupos.length > 0) {
                        for (const grupo of this.novos_grupos) {
                            // Validar que o grupo tem pelo menos um item
                            if (!grupo.itens || grupo.itens.length === 0) {
                                this.$message("Erro", `O grupo "${grupo.titulo}" precisa ter pelo menos um item`, "error");
                                this.saving = false;
                                return;
                            }

                            // Criar o grupo
                            const grupoResponse = await axios.post(
                                this.$store.state.api + "groupchecklists", 
                                { titulo: grupo.titulo }
                            );

                            const grupoId = grupoResponse.data?.data?.grupo_checklist_id || 
                                          grupoResponse.data?.grupo_checklist_id;

                            if (grupoId) {
                                gruposIds.push(Number(grupoId));

                                // Criar os itens deste grupo
                                for (const [itemIndex, item] of grupo.itens.entries()) {
                                    const itemResponse = await axios.post(
                                        this.$store.state.api + "itemchecklists",
                                        {
                                            grupo_checklist_id: grupoId,
                                            titulo: item.titulo,
                                            tipo_pergunta: item.tipo_pergunta,
                                            obrigatorio: !!item.obrigatorio,
                                            quantidade_esperada: item.quantidade_esperada ?? null,
                                            data_esperada: item.data_esperada ?? null,
                                            multipla_escolha: !!item.multipla_escolha,
                                            ordem: itemIndex,
                                        }
                                    );

                                    const itemId = itemResponse.data?.data?.item_checklist_id || 
                                                 itemResponse.data?.item_checklist_id;

                                    // Se for múltipla escolha (tipo 1), criar alternativas
                                    if (Number(item.tipo_pergunta) === 1 && item.alternativas && item.alternativas.length > 0) {
                                        for (const alternativa of item.alternativas) {
                                            await axios.post(
                                                this.$store.state.api + "respostachecklists",
                                                {
                                                    item_checklist_id: itemId,
                                                    titulo: alternativa.titulo,
                                                }
                                            );
                                        }
                                    }
                                }
                            }
                        }
                    }

                    // 3.5 Persistir a ordem e o grupo das perguntas existentes
                    //      (resultado do arraste entre grupos) — só agora, ao salvar.
                    const itensReorder = [];
                    this.selectedGroupsDetails.forEach(grupo => {
                        (grupo.itens_existentes || []).forEach((item, index) => {
                            if (!item.item_checklist_id) return;
                            itensReorder.push({
                                id: item.item_checklist_id,
                                grupo_checklist_id: grupo.grupo_checklist_id,
                                ordem: index,
                            });
                        });
                    });
                    if (itensReorder.length) {
                        await axios.post(
                            this.$store.state.api + "itemchecklists/reorder",
                            { items: itensReorder }
                        );
                    }

                    // 4. Atualizar o template com os IDs de todos os grupos
                    const payload = {
                        _method: "PUT",
                        nome: this.checklist_template.nome,
                        company_id: this.checklist_template.company_id,
                        units: Array.isArray(this.checklist_template.units)
                            ? this.checklist_template.units
                            : [],
                        grupos_checklist: gruposIds,
                        exibir_observacao: !!this.checklist_template.exibir_observacao,
                        informacoes_iniciais: this.checklist_template.informacoes_iniciais || null,
                    };

                    const api = this.$store.state.api + "checklisttemplates/" + this.checklist_template.checklist_template_id;
                    await axios.post(api, payload);

                } else {
                    // MODO CRIAÇÃO - enviar estrutura completa
                    const novosGruposParaCriar = this.novos_grupos.map(grupo => ({
                        titulo: grupo.titulo,
                        itens: (grupo.itens || []).map(item => ({
                            titulo: item.titulo,
                            tipo_pergunta: item.tipo_pergunta,
                            obrigatorio: !!item.obrigatorio,
                            quantidade_esperada: item.quantidade_esperada ?? null,
                            data_esperada: item.data_esperada ?? null,
                            multipla_escolha: !!item.multipla_escolha,
                            itens:
                                Number(item.tipo_pergunta) === 1
                                    ? (item.alternativas || []).map(a => ({
                                        titulo: a.titulo,
                                    }))
                                    : [],
                        })),
                    }));

                    const payload = {
                        nome: this.checklist_template.nome,
                        company_id: this.checklist_template.company_id,
                        units: Array.isArray(this.checklist_template.units)
                            ? this.checklist_template.units
                            : [],
                        grupos_checklist: novosGruposParaCriar,
                        exibir_observacao: !!this.checklist_template.exibir_observacao,
                        informacoes_iniciais: this.checklist_template.informacoes_iniciais || null,
                    };

                    const api = this.$store.state.api + "checklisttemplates";
                    await axios.post(api, payload);
                }

                this.$message("Sucesso", "Informações guardadas com sucesso", "success");
                this.$router.push("/checklisttemplates");
            } catch (error) {
                console.error("Erro ao salvar:", error);
                this.$message("Erro", error.response?.data?.message || error.message || "Erro ao salvar checklist", "error");
            } finally {
                this.saving = false;
            }
        },

        async salvarApenasTemplate() {
            if (!this.checklist_template.company_idm && this.isAdminLogged) {
                throw new Error("Selecione uma empresa");
            }

            let api = this.$store.state.api + "checklisttemplates";

            const payload = {
                nome: this.checklist_template.nome,
                company_id: this.checklist_template.company_id,
                units: this.checklist_template.units,
                grupos_checklist: this.checklist_template.grupos_checklist,
            };

            if (this.checklist_template.checklist_template_id) {
                payload._method = "PUT";
                api += "/" + this.checklist_template.checklist_template_id;
            }

            await axios.post(api, payload);
        },

        async criarNovosGrupos(grupos) {
            const requests = grupos.map(grupo =>
                axios.post(this.$store.state.api + "groupchecklists", grupo)
            );

            const responses = await Promise.all(requests);

            return responses
                .map(response => {
                    if (response.data?.data?.grupo_checklist_id) {
                        return Number(response.data.data.grupo_checklist_id);
                    }

                    if (response.data?.grupo_checklist_id) {
                        return Number(response.data.grupo_checklist_id);
                    }

                    if (response.data?.data?.id) {
                        return Number(response.data.data.id);
                    }

                    if (response.data?.id) {
                        return Number(response.data.id);
                    }

                    return null;
                })
                .filter(Boolean);
        },

        async criarNovosItens(itens) {
            const requests = itens.map(item =>
                axios.post(this.$store.state.api + "itemchecklists", item)
            );

            await Promise.all(requests);
        },

        coletarNovosGrupos() {
            return this.novos_grupos
                .filter(grupo => grupo.titulo && grupo.titulo.trim())
                .map(grupo => ({
                    titulo: grupo.titulo.trim(),
                }));
        },

        coletarItensDeNovosGrupos() {
            const itens = [];

            this.novos_grupos.forEach((grupo, grupoIndex) => {
                if (!grupo.titulo || !grupo.titulo.trim()) {
                    return;
                }

                if (!Array.isArray(grupo.itens) || grupo.itens.length === 0) {
                    return;
                }

                grupo.itens.forEach(item => {
                    if (!item.titulo || !item.titulo.trim()) {
                        return;
                    }

                    const novoItem = {
                        titulo: item.titulo.trim(),
                        tipo_pergunta: Number(item.tipo_pergunta) || 1,
                        indiceGrupoOriginal: grupoIndex,
                    };

                    if (Number(item.tipo_pergunta) === 1 && Array.isArray(item.alternativas)) {
                        novoItem.itens = item.alternativas
                            .filter(alt => alt.titulo && alt.titulo.trim())
                            .map(alt => ({ titulo: alt.titulo.trim() }));
                    }

                    itens.push(novoItem);
                });
            });

            return itens;
        },

        coletarNovosItens() {
            const novosItens = [];

            this.selectedGroupsDetails.forEach(grupo => {
                if (!Array.isArray(grupo.novos_itens) || grupo.novos_itens.length === 0) {
                    return;
                }

                const ordemOffset = Array.isArray(grupo.itens_existentes) ? grupo.itens_existentes.length : 0;

                grupo.novos_itens.forEach((item, index) => {
                    if (!item.titulo || !item.titulo.trim()) {
                        return;
                    }

                    const novoItem = {
                        titulo: item.titulo.trim(),
                        grupo_checklist_id: grupo.grupo_checklist_id,
                        tipo_pergunta: Number(item.tipo_pergunta) || 1,
                        obrigatorio: !!item.obrigatorio,
                        quantidade_esperada: item.quantidade_esperada ?? null,
                        data_esperada: item.data_esperada ?? null,
                        multipla_escolha: !!item.multipla_escolha,
                        ordem: ordemOffset + index,
                    };

                    if (Number(item.tipo_pergunta) === 1 && Array.isArray(item.itens)) {
                        novoItem.itens = item.itens
                            .filter(alt => alt.titulo && alt.titulo.trim())
                            .map(alt => ({ titulo: alt.titulo.trim() }));
                    }

                    novosItens.push(novoItem);
                });
            });

            return novosItens;
        },

        carregarDetalhesGruposSelecionados() {
            if (this.editandoItem) {
                return;
            }

            const algumGrupoEditandoNome = this.selectedGroupsDetails.some(g => g.editandoNome);
            if (algumGrupoEditandoNome) {
                return;
            }

            if (
                !Array.isArray(this.checklist_template.grupos_checklist) ||
                this.checklist_template.grupos_checklist.length === 0
            ) {
                this.selectedGroupsDetails = [];
                return;
            }

            const gruposSelecionados = this.checklist_template.grupos_checklist;

            const detalhesAtuaisMap = new Map(
                this.selectedGroupsDetails.map(grupo => [Number(grupo.grupo_checklist_id), grupo])
            );

            this.selectedGroupsDetails = gruposSelecionados
                .map(grupoId => {
                    const grupoBase = this.group_checklists.find(
                        group => Number(group.grupo_checklist_id) === Number(grupoId)
                    );

                    if (!grupoBase) {
                        return null;
                    }

                    const atual = detalhesAtuaisMap.get(Number(grupoId));

                    return {
                        ...grupoBase,
                        titulo: atual ? atual.titulo : grupoBase.titulo,
                        itens_existentes: atual?.itens_existentes || [],
                        novos_itens: atual?.novos_itens || [],
                        collapsed: typeof atual?.collapsed === "boolean" ? atual.collapsed : true,
                    };
                })
                .filter(Boolean);

            this.selectedGroupsDetails.forEach(grupo => {
                this.buscarItensDoGrupo(grupo);
            });
        },

        async buscarItensDoGrupo(grupo) {
            try {
                const api =
                    this.$store.state.api +
                    "itemchecklists?grupo_checklist_id=" +
                    grupo.grupo_checklist_id +
                    "&paginated=false";

                const response = await axios.get(api);

                const itens = response.data.data || [];

                // Ordenar por ordem definida; se ordem for null, cai em ordem alfabética
                const itensOrdenados = itens.sort((a, b) => {
                    if (a.ordem !== null && a.ordem !== undefined && b.ordem !== null && b.ordem !== undefined) {
                        return a.ordem - b.ordem;
                    }
                    if (a.ordem !== null && a.ordem !== undefined) return -1;
                    if (b.ordem !== null && b.ordem !== undefined) return 1;
                    return (a.titulo || "").localeCompare(b.titulo || "", "pt-BR", { sensitivity: "base" });
                });

                const indiceExistente = this.selectedGroupsDetails.findIndex(
                    item => Number(item.grupo_checklist_id) === Number(grupo.grupo_checklist_id)
                );

                if (indiceExistente >= 0) {
                    this.$set(this.selectedGroupsDetails[indiceExistente], "itens_existentes", itensOrdenados);
                }
            } catch (error) {
                const indiceExistente = this.selectedGroupsDetails.findIndex(
                    item => Number(item.grupo_checklist_id) === Number(grupo.grupo_checklist_id)
                );

                if (indiceExistente >= 0) {
                    this.$set(this.selectedGroupsDetails[indiceExistente], "itens_existentes", []);
                }
            }
        },

        formatarData(valor) {
            if (!valor) return "";
            const [ano, mes, dia] = String(valor).substring(0, 10).split("-");
            return dia && mes && ano ? `${dia}/${mes}/${ano}` : valor;
        },

        getTipoLabel(tipo_pergunta) {
            const tipos = {
                1: "Alternativa",
                2: "Texto",
                3: "Número",
                4: "Imagem",
                5: "Data",
            };

            return tipos[Number(tipo_pergunta)] || "Desconhecido";
        },

        getTipoBadgeClass(tipo_pergunta) {
            const classes = {
                1: "badge-alternativa",
                2: "badge-texto",
                3: "badge-numero",
                4: "badge-imagem",
                5: "badge-data",
            };

            return classes[Number(tipo_pergunta)] || "badge-secondary";
        },

        editarNomeGrupo(grupo) {
            this.$set(grupo, "tituloEditando", grupo.titulo);
            this.$set(grupo, "editandoNome", true);
        },

        cancelarEdicaoNomeGrupo(grupo) {
            this.$set(grupo, "editandoNome", false);
            this.$delete(grupo, "tituloEditando");
        },

        async salvarNomeGrupo(grupo) {
            const novoTitulo = (grupo.tituloEditando || "").trim();

            if (!novoTitulo) {
                this.$message("Erro", "O nome do grupo não pode estar vazio.", "error");
                return;
            }

            try {
                await axios.put(this.$store.state.api + "groupchecklists/" + grupo.grupo_checklist_id, {
                    titulo: novoTitulo,
                });

                grupo.titulo = novoTitulo;
                this.$set(grupo, "editandoNome", false);
                this.$delete(grupo, "tituloEditando");
            } catch (error) {
                this.$message("Erro", error.response?.data?.message || "Erro ao salvar nome do grupo.", "error");
            }
        },

        editarItemExistente(item) {
            this.editandoItem = true;

            this.$set(
                item,
                "original",
                JSON.parse(
                    JSON.stringify({
                        titulo: item.titulo,
                        tipo_pergunta: item.tipo_pergunta,
                        itens: item.itens || [],
                        item_checklist_id: item.item_checklist_id,
                        grupo_checklist_id: item.grupo_checklist_id,
                        multipla_escolha: !!item.multipla_escolha,
                        obrigatorio: !!item.obrigatorio,
                        quantidade_esperada: item.quantidade_esperada ?? null,
                        data_esperada: item.data_esperada ?? null,
                    })
                )
            );

            if (Number(item.tipo_pergunta) === 1) {
                this.carregarAlternativasItem(item);
            }

            this.$set(item, "editando", true);
            this.$set(item, "mostrarAlternativas", false);
        },

        async carregarAlternativasItem(item) {
            try {
                const api =
                    this.$store.state.api +
                    "respostachecklists?item_checklist_id=" +
                    item.item_checklist_id +
                    "&paginated=false";

                const response = await axios.get(api);
                this.$set(item, "itens", response.data.data || []);
            } catch (error) {
                this.$set(item, "itens", []);
            }
        },

        async salvarEdicaoItemExistente(item) {
            if (!item.titulo || !item.titulo.trim()) {
                this.$message("Erro", "O título do item não pode estar vazio", "error");
                return;
            }

            try {
                const api = this.$store.state.api + "itemchecklists/" + item.item_checklist_id;

                const dados = {
                    titulo: item.titulo.trim(),
                    tipo_pergunta: Number(item.tipo_pergunta),
                    grupo_checklist_id: item.grupo_checklist_id,
                    obrigatorio: !!item.obrigatorio,
                    quantidade_esperada: item.quantidade_esperada ?? null,
                    data_esperada: item.data_esperada ?? null,
                    multipla_escolha: !!item.multipla_escolha,
                };

                if (Number(item.tipo_pergunta) === 1 && Array.isArray(item.itens)) {
                    dados.itens = item.itens
                        .filter(alt => alt.titulo && alt.titulo.trim())
                        .map(alt => ({
                            titulo: alt.titulo.trim(),
                            resposta_checklist_id: alt.resposta_checklist_id || undefined,
                            item_vinculado_id: alt.item_vinculado_id || null,
                        }));
                }

                await axios.put(api, dados);

                this.$set(item, "editando", false);
                this.$delete(item, "original");
                this.$delete(item, "mostrarAlternativas");
                this.editandoItem = false;

                this.$message("Sucesso", "Item atualizado com sucesso", "success");
            } catch (error) {
                this.editandoItem = false;
                this.$message(
                    "Erro",
                    error.response?.data?.message || error.message || "Erro ao atualizar item",
                    "error"
                );
            }
        },

        cancelarEdicaoItemExistente(item) {
            if (item.original) {
                item.titulo = item.original.titulo;
                item.tipo_pergunta = item.original.tipo_pergunta;
                item.itens = item.original.itens;
                item.item_checklist_id = item.original.item_checklist_id;
                item.grupo_checklist_id = item.original.grupo_checklist_id;
                item.multipla_escolha = item.original.multipla_escolha;
                item.obrigatorio = item.original.obrigatorio;
                item.quantidade_esperada = item.original.quantidade_esperada;
                item.data_esperada = item.original.data_esperada;
                this.$delete(item, "original");
            }

            this.$set(item, "editando", false);
            this.$delete(item, "mostrarAlternativas");
            this.editandoItem = false;
        },

        gerenciarAlternativasItemExistente(item) {
            this.$set(item, "mostrarAlternativas", !item.mostrarAlternativas);

            if (!item.itens) {
                this.$set(item, "itens", []);
            }
        },

        adicionarAlternativaItemExistente(item) {
            if (!item.itens) {
                this.$set(item, "itens", []);
            }

            item.itens.push({ titulo: "" });
        },

        removerAlternativaItemExistente(item, index) {
            item.itens.splice(index, 1);
        },

        adicionarNovoGrupo() {
            this.novos_grupos.push({
                titulo: "",
                itens: [],
                collapsed: false,
            });
        },

        abrirImportModal() {
            this.importErrors = [];
            if (this.$refs.fileImportRef) {
                this.$refs.fileImportRef.value = "";
            }
            this.showImportModal = true;
        },

        fecharImportModal() {
            this.showImportModal = false;
        },

        async baixarModeloImportacao() {
            this.baixandoModelo = true;

            try {
                const response = await axios.get(
                    this.$store.state.api + "checklisttemplates/import-model",
                    { responseType: "blob" }
                );

                const url = window.URL.createObjectURL(
                    new Blob([response.data], {
                        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                    })
                );
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", "modelo_importacao_checklist.xlsx");
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            } catch (error) {
                this.$message("Erro", "Não foi possível baixar o modelo.", "error");
            } finally {
                this.baixandoModelo = false;
            }
        },

        importarPlanilha() {
            const self = this;
            const fileInput = self.$refs.fileImportRef;

            if (!fileInput || !fileInput.files[0]) {
                self.$message("Atenção", "Selecione um arquivo para importar.", "warning");
                return;
            }

            const fd = new FormData();
            fd.append("fileImport", fileInput.files[0]);

            self.importing = true;
            self.importErrors = [];

            axios
                .post(self.$store.state.api + "checklisttemplates/import-preview", fd)
                .then(response => {
                    const grupos = response.data.grupos || [];
                    self.importErrors = response.data.errors || [];

                    grupos.forEach(grupo => {
                        self.novos_grupos.push({
                            titulo: grupo.titulo,
                            collapsed: false,
                            itens: (grupo.itens || []).map(item => ({
                                titulo: item.titulo,
                                tipo_pergunta: item.tipo_pergunta,
                                obrigatorio: !!item.obrigatorio,
                                quantidade_esperada: item.quantidade_esperada ?? null,
                                data_esperada: item.data_esperada ?? null,
                                multipla_escolha: !!item.multipla_escolha,
                                mostrarAlternativas: Number(item.tipo_pergunta) === 1,
                                alternativas: (item.alternativas || []).map(alt => ({
                                    titulo: alt.titulo,
                                })),
                            })),
                        });
                    });

                    const totalItens = response.data.imported || 0;
                    const totalErros = self.importErrors.length;

                    if (totalItens > 0) {
                        const mensagem = totalErros > 0
                            ? `${totalItens} item(ns) importado(s), mas ${totalErros} linha(s) tiveram problema e foram ignoradas (veja abaixo).`
                            : `${totalItens} item(ns) importado(s). Revise os grupos e clique em Salvar para gravar o checklist.`;

                        self.$message("Sucesso", mensagem, totalErros > 0 ? "warning" : "success");

                        // Só fecha o modal automaticamente quando não sobrou nenhum
                        // erro pra revisar - senão a pessoa nunca veria o motivo
                        // de alguma linha não ter sido importada.
                        if (totalErros === 0) {
                            self.showImportModal = false;
                        }
                    }
                })
                .catch(error => {
                    const data = error.response?.data;

                    if (data?.errors && !Array.isArray(data.errors)) {
                        const msgs = Object.values(data.errors).flat().join(" ");
                        self.$message("Erro de validação", msgs, "error");
                    } else {
                        self.importErrors = data?.errors || [];
                        self.$message(
                            "Erro na importação",
                            data?.message || "Houve um erro inesperado. Verifique o arquivo e tente novamente.",
                            "error"
                        );
                    }
                })
                .finally(() => {
                    self.importing = false;
                });
        },

        // Clona os itens de um grupo para o formato de "item novo" (editável).
        // Não copia vínculos condicionais (item_vinculado_id), pois apontam para
        // IDs de itens que não existem na cópia.
        _clonarItensParaNovoGrupo(itens, campoAlternativas) {
            return (itens || []).map(item => ({
                titulo: item.titulo,
                tipo_pergunta: item.tipo_pergunta,
                obrigatorio: !!item.obrigatorio,
                quantidade_esperada: item.quantidade_esperada ?? null,
                data_esperada: item.data_esperada ?? null,
                multipla_escolha: !!item.multipla_escolha,
                mostrarAlternativas: false,
                alternativas: (item[campoAlternativas] || []).map(alt => ({
                    titulo: alt.titulo,
                })),
            }));
        },

        duplicarNovoGrupo(index) {
            const origem = this.novos_grupos[index];
            if (!origem) return;

            this.novos_grupos.push({
                titulo: (origem.titulo || "Grupo") + " (cópia)",
                collapsed: false,
                itens: this._clonarItensParaNovoGrupo(origem.itens, "alternativas"),
            });

            this.$message(
                "Sucesso",
                "Grupo duplicado. Edite os itens e clique em Salvar.",
                "success"
            );
        },

        duplicarGrupoExistente(grupo) {
            if (!grupo) return;

            this.novos_grupos.push({
                titulo: (grupo.titulo || "Grupo") + " (cópia)",
                collapsed: false,
                // itens existentes guardam as alternativas em `item.itens`
                itens: this._clonarItensParaNovoGrupo(grupo.itens_existentes, "itens"),
            });

            this.$message(
                "Sucesso",
                "Grupo duplicado. Edite os itens e clique em Salvar.",
                "success"
            );
        },

        validarNomeGrupo(grupo, index) {
            if (!grupo.titulo || !grupo.titulo.trim()) {
                this.$nextTick(() => {
                    const input = document.querySelectorAll(".grupo-nome-input")[index];
                    if (input) {
                        input.focus();
                    }
                });
            }
        },

        toggleGrupoCollapse(tipo, id) {
            if (tipo === "novo") {
                const grupo = this.novos_grupos[id];
                if (grupo) {
                    this.$set(grupo, "collapsed", !grupo.collapsed);
                }
                return;
            }

            const grupo = this.selectedGroupsDetails.find(
                item => Number(item.grupo_checklist_id) === Number(id)
            );

            if (grupo) {
                this.$set(grupo, "collapsed", !grupo.collapsed);
            }
        },

        confirmarRemoverNovoGrupo(index) {
            if (!this.novos_grupos[index]) {
                return;
            }

            this.novoGrupoParaDeletar = {
                index,
                grupo: this.novos_grupos[index],
            };

            this.showDeleteNovoGrupoModal = true;
        },

        removerNovoGrupo() {
            if (
                this.novoGrupoParaDeletar !== null &&
                typeof this.novoGrupoParaDeletar.index === "number"
            ) {
                const grupoTitulo = this.novoGrupoParaDeletar.grupo.titulo || "Grupo sem nome";

                this.novos_grupos.splice(this.novoGrupoParaDeletar.index, 1);
                this.showDeleteNovoGrupoModal = false;
                this.novoGrupoParaDeletar = null;

                this.$message("Sucesso", `Grupo "${grupoTitulo}" removido com sucesso`, "success");
            }
        },

        cancelarDeleteNovoGrupo() {
            this.showDeleteNovoGrupoModal = false;
            this.novoGrupoParaDeletar = null;
        },

        adicionarItemAoNovoGrupo(grupoIndex) {
            const grupo = this.novos_grupos[grupoIndex];

            if (!grupo.itens) {
                this.$set(grupo, "itens", []);
            }

            grupo.itens.push({
                titulo: "",
                tipo_pergunta: 1,
                obrigatorio: true,
                quantidade_esperada: null,
                data_esperada: null,
                multipla_escolha: false,
                alternativas: [],
                mostrarAlternativas: false,
            });
        },

        removerItemDoNovoGrupo(grupoIndex, itemIndex) {
            this.novos_grupos[grupoIndex].itens.splice(itemIndex, 1);
        },

        gerenciarAlternativasNovoGrupo(grupoIndex, itemIndex) {
            const item = this.novos_grupos[grupoIndex].itens[itemIndex];
            item.mostrarAlternativas = !item.mostrarAlternativas;

            if (!item.alternativas) {
                this.$set(item, "alternativas", []);
            }
        },

        adicionarAlternativaNovoGrupo(item) {
            if (!item.alternativas) {
                this.$set(item, "alternativas", []);
            }

            item.alternativas.push({ titulo: "" });
        },

        removerAlternativaNovoGrupo(item, index) {
            item.alternativas.splice(index, 1);
        },

        adicionarNovoItem(grupo) {
            if (!grupo.novos_itens) {
                this.$set(grupo, "novos_itens", []);
            }

            grupo.novos_itens.push({
                titulo: "",
                tipo_pergunta: 1,
                obrigatorio: true,
                quantidade_esperada: null,
                data_esperada: null,
                multipla_escolha: false,
                itens: [],
                mostrarAlternativas: false,
            });
        },

        removerNovoItem(grupo, index) {
            grupo.novos_itens.splice(index, 1);
        },

        gerenciarAlternativas(grupo, itemIndex) {
            const item = grupo.novos_itens[itemIndex];
            item.mostrarAlternativas = !item.mostrarAlternativas;

            if (!item.itens) {
                this.$set(item, "itens", []);
            }
        },

        adicionarAlternativa(item) {
            if (!item.itens) {
                this.$set(item, "itens", []);
            }

            item.itens.push({ titulo: "" });
        },

        removerAlternativa(item, index) {
            item.itens.splice(index, 1);
        },

        confirmarDeleteGrupoExistente(grupo) {
            this.grupoParaDeletar = grupo;
            this.showDeleteModal = true;
        },

        async deletarGrupoExistente() {
            const grupo = this.grupoParaDeletar;

            if (!grupo) {
                return;
            }

            try {
                this.showDeleteModal = false;
                this.$message("Info", "Deletando grupo e todos os seus itens...", "info");

                const deleteItens = (grupo.itens_existentes || []).map(item =>
                    axios.delete(this.$store.state.api + "itemchecklists/" + item.item_checklist_id)
                );

                await Promise.all(deleteItens);
                await axios.delete(this.$store.state.api + "groupchecklists/" + grupo.grupo_checklist_id);

                this.checklist_template.grupos_checklist = this.checklist_template.grupos_checklist.filter(
                    id => Number(id) !== Number(grupo.grupo_checklist_id)
                );

                this.selectedGroupsDetails = this.selectedGroupsDetails.filter(
                    item => Number(item.grupo_checklist_id) !== Number(grupo.grupo_checklist_id)
                );

                this.$message(
                    "Sucesso",
                    `Grupo "${grupo.titulo}" e seus itens foram deletados com sucesso`,
                    "success"
                );
            } catch (error) {
                this.$message(
                    "Erro",
                    error.response?.data?.message || error.message || "Erro ao deletar grupo",
                    "error"
                );
            } finally {
                this.grupoParaDeletar = null;
            }
        },

        cancelarDeleteGrupo() {
            this.showDeleteModal = false;
            this.grupoParaDeletar = null;
        },

        confirmarDeleteItemExistente(grupo, item) {
            this.itemParaDeletar = { grupo, item };
            this.showDeleteItemModal = true;
        },

        async deletarItemExistente() {
            if (!this.itemParaDeletar?.grupo || !this.itemParaDeletar?.item) {
                return;
            }

            const { grupo, item } = this.itemParaDeletar;

            try {
                this.showDeleteItemModal = false;

                const api = this.$store.state.api + "itemchecklists/" + item.item_checklist_id;
                await axios.delete(api);

                grupo.itens_existentes = grupo.itens_existentes.filter(
                    current => Number(current.item_checklist_id) !== Number(item.item_checklist_id)
                );

                this.$message("Sucesso", `Item "${item.titulo}" deletado com sucesso`, "success");
            } catch (error) {
                this.$message(
                    "Erro",
                    error.response?.data?.message || error.message || "Erro ao deletar item",
                    "error"
                );
            } finally {
                this.itemParaDeletar = null;
            }
        },

        cancelarDeleteItem() {
            this.showDeleteItemModal = false;
            this.itemParaDeletar = null;
        },

        getNomeItemVinculado(grupo, itemVinculadoId) {
            if (!itemVinculadoId || !grupo?.itens_existentes) return '';
            const found = grupo.itens_existentes.find(i => Number(i.item_checklist_id) === Number(itemVinculadoId));
            return found ? found.titulo : '';
        },
    },
};
</script>
<style scoped>
/* Variáveis de tema */
:root {
    --bg-card: #ffffff;
    --bg-muted: #f8f9fa;
    --bg-light: #e9ecef;
    --border-color: #dee2e6;
    --border-light: #e9ecef;
    --text-primary: #495057;
    --text-muted: #6c757d;
    --shadow-card: rgba(0, 0, 0, 0.1);
    --shadow-card-hover: rgba(0, 0, 0, 0.15);
}

[data-theme="dark"] {
    --bg-card: #2d3748;
    --bg-muted: #1a202c;
    --bg-light: #4a5568;
    --border-color: #4a5568;
    --border-light: #2d3748;
    --text-primary: #e2e8f0;
    --text-muted: #a0aec0;
    --shadow-card: rgba(0, 0, 0, 0.3);
    --shadow-card-hover: rgba(0, 0, 0, 0.4);
}

.profile_user {
    text-align: center;
}

.photo {
    display: block;
    margin-left: 5px;
    width: 18%;
    border-radius: 10px;
    max-width: 400px;
    max-height: 400px;
    object-fit: cover;
}

.btn-user:hover,
.btn-user[aria-expanded="true"] {
    background: linear-gradient(to right, #000, #666);
    color: #fff !important;
}

/* CSS customizado para os modais */
.modal-overlay-custom {
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    width: 100vw !important;
    height: 100vh !important;
    background-color: rgba(0, 0, 0, 0.6) !important;
    z-index: 99999 !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    overflow: auto !important;
}

.modal-dialog-custom {
    max-width: 500px !important;
    width: 90% !important;
    margin: 20px !important;
    position: relative !important;
}

.modal-content-custom {
    background-color: white !important;
    border-radius: 8px !important;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.3) !important;
    overflow: hidden !important;
    max-height: 90vh !important;
    overflow-y: auto !important;
}

.modal-header {
    padding: 1rem 1.5rem !important;
    border-bottom: 1px solid #dee2e6 !important;
    border-top-left-radius: calc(0.375rem - 1px) !important;
    border-top-right-radius: calc(0.375rem - 1px) !important;
}

.modal-body {
    padding: 1.5rem !important;
    position: relative !important;
}

.modal-footer {
    padding: 1rem 1.5rem !important;
    border-top: 1px solid #dee2e6 !important;
    border-bottom-right-radius: calc(0.375rem - 1px) !important;
    border-bottom-left-radius: calc(0.375rem - 1px) !important;
    display: flex !important;
    justify-content: flex-end !important;
    gap: 10px !important;
}

.modal-title {
    font-size: 1.25rem !important;
    font-weight: 500 !important;
    margin-bottom: 0 !important;
}

.photo-title {
    color: #000;
    font-size: 18px;
    display: block;
    margin-left: 5px;
    width: 18%;
}

/* Layout principal dos grupos */
.grupos-management {
    background: var(--bg-muted);
    border-radius: 8px;
    padding: 20px;
    box-shadow: #00000063 0px 4px 12px;
    margin-bottom: 100px;
}

.grupos-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    padding-bottom: 15px;
    border-bottom: 2px solid var(--border-color);
}

.grupos-header h5 {
    margin: 0;
    color: var(--text-primary);
    font-weight: 600;
}

.grupos-container {
    display: flex;
    flex-direction: column;
    gap: 20px;
    min-height: 100px;
}

/* Grupos existentes primeiro; novos/duplicados sempre abaixo da última pergunta */
.grupos-existentes-section {
    order: 1;
}

.grupos-novos-section {
    order: 2;
}

/* Cards dos grupos */
.grupo-card {
    background: var(--bg-card);
    border-radius: 12px;
    box-shadow: #00000029 0px 2px 8px;
    border: 2px solid transparent;
    transition: all 0.3s ease;
    /* Sem overflow: hidden para o calendário (b-form-datepicker) não ser cortado */
    overflow: visible;
    position: relative;
}

/* Card com o calendário aberto fica por cima dos grupos seguintes */
.grupo-card:focus-within {
    z-index: 2;
    transform: none !important;
}

.grupo-card:hover {
    box-shadow: #00000077 0px 2px 8px;
    transform: translateY(-2px);
}

.grupo-novo {
    border-left: 4px solid #28a745;
}

.grupo-existente {
    border-left: 4px solid #007bff;
}

/* Cabeçalho do grupo */
.grupo-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 20px;
    background: linear-gradient(135deg, var(--bg-muted) 0%, var(--bg-light) 100%);
    border-bottom: 1px solid var(--border-color);
    border-radius: 10px 10px 0 0;
}

.drag-handle,
.drag-handle-item {
    cursor: grab;
    opacity: 0.4;
    transition: opacity 0.15s;
    flex-shrink: 0;
}

.drag-handle:hover,
.drag-handle-item:hover {
    opacity: 1;
}

.drag-handle:active,
.drag-handle-item:active {
    cursor: grabbing;
}

.dragging-ghost {
    opacity: 0.4;
    border: 2px dashed var(--border-color) !important;
}

/* Zona de drop das perguntas: garante área para soltar mesmo em grupo vazio */
.itens-drop-zone {
    min-height: 44px;
}

.itens-drop-zone:empty {
    border: 2px dashed var(--border-color);
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.itens-drop-zone:empty::before {
    content: "Arraste perguntas para cá";
    color: #a0a0a0;
    font-size: 0.85rem;
    font-style: italic;
}

.grupo-actions {
    display: flex;
    gap: 5px;
    align-items: center;
}

.grupo-title h6 {
    margin: 0;
    font-weight: 600;
    color: var(--text-primary);
}

.grupo-nome-input {
    border: 1px solid #ffffff;
    background: rgba(0, 0, 0, 0.048);
    font-size: 16px;
    font-weight: 600;
    color: var(--text-primary);
    padding: 5px 15px;
}

.grupo-nome-input:focus {
    outline: none;
    border-bottom: 2px solid #007bff;
    background: var(--bg-card);
    padding: 5px 10px;
    border-radius: 4px;
}

.grupo-status {
    font-size: 12px;
    color: var(--text-muted);
    background: var(--bg-light);
    padding: 2px 8px;
    border-radius: 12px;
    margin-top: 2px;
    display: inline-block;
}

/* Seção dos itens */
.grupo-itens {
    padding: 20px;
}

.item-linha {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 12px;
    margin-bottom: 10px;
    background: var(--bg-muted);
    border-radius: 8px;
    border: 1px solid var(--border-light);
    transition: all 0.2s ease;
}

.item-linha:hover {
    background: var(--bg-light);
    border-color: var(--border-color);
}

.item-content {
    display: flex;
    gap: 10px;
    flex: 1;
    align-items: center;
}

.item-nome {
    flex: 1;
    font-size: 14px;
}

.item-tipo {
    flex: 1;
    font-size: 14px;
}

.item-existente {
    display: flex;
    align-items: flex-start;
    padding: 8px 12px;
    background: #e7f3ff !important;
    border: 1px solid #b8daff;
    border-radius: 6px;
    margin-bottom: 8px;
    font-size: 14px;
    transition: all 0.2s ease;
}

.item-existente:hover {
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    border-color: #007bff;
}

.item-view-mode {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
}

.item-edit-mode {
    width: 100%;
}

.item-edit-header {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 10px;
    padding: 6px 10px;
    background-color: #e7f3ff;
    border-left: 3px solid #007bff;
    border-radius: 4px;
}

.item-edit-header i {
    font-size: 14px;
}

.item-edit-header span {
    font-size: 13px;
}

.item-edit-mode .item-content {
    display: flex;
    gap: 8px;
    margin-bottom: 8px;
    align-items: center;
}

.item-edit-mode .item-actions {
    display: flex;
    gap: 8px;
    margin-bottom: 8px;
}

.item-info {
    display: flex;
    align-items: center;
    gap: 10px;
    flex: 1;
}

.item-info .item-titulo {
    color: #004085 !important;
}

.item-actions {
    display: flex;
    gap: 6px;
    margin-left: 20px;
}

.item-actions .btn {
    white-space: nowrap;
}

.badge-tipo {
    padding: 4px 8px;
    font-size: 11px;
    font-weight: 600;
    border-radius: 4px;
    text-transform: uppercase;
}

.badge-alternativa {
    background: #d1ecf1 !important;
    color: #0c5460 !important;
}

.badge-texto {
    background: #d4edda !important;
    color: #155724 !important;
}

.badge-numero {
    background: #fff3cd !important;
    color: #856404 !important;
}

.badge-imagem {
    background: #f8d7da !important;
    color: #721c24 !important;
}

.badge-data {
    background: #d1ecf1 !important;
    color: #0c5460 !important;
}

.badge-obrigatorio {
    font-size: 11px;
    font-weight: 600;
    border-radius: 4px;
    padding: 2px 7px;
}

.badge-obrig {
    background: #ffeeba !important;
    color: #856404 !important;
}

.badge-opcional {
    background: #cce5ff !important;
    color: #004085 !important;
}

.item-obrigatorio-switch {
    display: inline-flex;
    align-items: center;
    white-space: nowrap;
    font-size: 0.82rem;
}

.item-quantidade-esperada {
    flex: 0 0 140px;
    font-size: 14px;
}

.item-data-esperada {
    display: flex;
    align-items: center;
}

.item-data-esperada ::v-deep .form-control {
    border: none;
    background: transparent;
    font-size: 14px;
}

.item-titulo {
    flex: 1;
    color: #004085 !important;
}

.itens-existentes {
    margin-bottom: 15px;
    padding-bottom: 15px;
    border-bottom: 1px solid var(--border-light);
}

/* Modo Dark - ajustes para item existente */
@media (prefers-color-scheme: dark) {
    .item-existente {
        background: transparent !important;
        border: none;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
    }
    
    .item-existente:hover {
        box-shadow: 0 2px 6px rgba(0, 0, 0, 0.5);
    }
    
    .item-info .item-titulo {
        color: inherit !important;
    }
    
    .item-edit-header {
        background-color: rgba(0, 123, 255, 0.15);
        border-left-color: #007bff;
    }
}

/* Seção de alternativas */
.alternativas-section {
    width: 35%;
    margin-top: 10px;
    padding: 15px;
    background: var(--bg-light);
    border-radius: 8px;
    border-left: 3px solid var(--text-muted);
}

.alternativas-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    font-size: 12px;
    font-weight: 600;
    color: var(--text-primary);
}

.alternativa-linha {
    display: flex;
    gap: 8px;
    margin-bottom: 8px;
    align-items: center;
}

.alternativa-linha .form-control {
    flex: 1;
    font-size: 13px;
    padding: 6px 10px;
}

/* Painel de vínculo entre perguntas */
.vinculo-panel {
    margin-left: 16px;
    margin-bottom: 10px;
    padding: 12px 14px;
    background: #fff8e1;
    border: 1px solid #ffc107;
    border-left: 4px solid #ffc107;
    border-radius: 6px;
}

.vinculo-panel-header {
    font-size: 13px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 4px;
    margin-bottom: 4px;
}

.gap-2 {
    gap: 8px;
}

/* Botão adicionar item */
.adicionar-item {
    text-align: center;
    padding: 15px;
    border-top: 1px dashed #dee2e6;
    margin-top: 10px;
}

.adicionar-item button {
    border-style: dashed;
    color: #28a745;
    border-color: #28a745;
    background: transparent;
}

.adicionar-item button:hover {
    background: #28a745;
    color: white;
    border-style: solid;
}

/* Mensagem sem grupos */
.sem-grupos {
    text-align: center;
    padding: 60px 20px;
    color: #6c757d;
    grid-column: 1 / -1;
}

.sem-grupos i {
    font-size: 48px;
    margin-bottom: 15px;
    opacity: 0.5;
}

.sem-grupos p {
    font-size: 16px;
    margin: 0;
}

/* Botões menores */
.btn-xs {
    padding: 0.125rem 0.25rem;
    font-size: 0.75rem;
    line-height: 1.2;
    border-radius: 0.2rem;
}

/* Responsividade */
@media (max-width: 768px) {
    .item-content {
        flex-direction: column;
        gap: 8px;
    }

    .item-nome,
    .item-tipo {
        flex: none;
        width: 100%;
    }

    .grupos-header {
        flex-direction: column;
        gap: 15px;
        text-align: center;
    }
}

/* Estilos dos modais */
.modal {
    z-index: 1050;
}

.modal-dialog-centered {
    display: flex;
    align-items: center;
    min-height: calc(100% - 1rem);
}

.modal-content {
    border-radius: 12px;
    border: none;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
}

.modal-header {
    border-radius: 12px 12px 0 0;
    border-bottom: none;
    padding: 20px 30px;
}

.modal-body {
    padding: 30px;
}

.modal-footer {
    border-top: 1px solid #e9ecef;
    border-radius: 0 0 12px 12px;
    padding: 20px 30px;
    justify-content: space-between;
}

.modal-title {
    font-weight: 600;
}

/* Estilos antigos mantidos */
.card-header.bg-light {
    background-color: #f8f9fa !important;
    border-bottom: 1px solid #dee2e6;
}

.card.border-primary {
    border-color: #007bff !important;
}

.card.border-success {
    border-color: #28a745 !important;
}

.card-header.bg-success {
    background-color: #28a745 !important;
    border-bottom: 1px solid #1e7e34;
}

.badge-secondary {
    font-size: 0.85em;
    margin-right: 5px;
    margin-bottom: 5px;
}

.btn-xs {
    padding: 0.125rem 0.25rem;
    font-size: 0.75rem;
    line-height: 1.2;
    border-radius: 0.2rem;
}

.form-control-xs {
    padding: 0.125rem 0.375rem;
    font-size: 0.75rem;
    line-height: 1.2;
}

.border-top {
    border-top: 1px solid #dee2e6 !important;
}

.text-muted.font-weight-bold {
    font-weight: 600 !important;
}
</style>